(function () {
/**
 * @typedef {Object} Player
 * @property {string} name
 * @property {Leader} Leader
 * @property {Base} base
 * @property {number} remainingHp
 * @property {boolean} hasInitiative
 * @property {boolean} hasUsedEpicAction

 * @typedef {Object} StateSettings
 * @property {boolean} countUp
 * @property {string} bottomPlayerName


 * @typedef {Object} StateGame
 * @property {number} rounds
 * @property {Base} topBase
 * @property {Leader} topLeader
 * @property {Base} bottomBase
 * @property {Leader} bottomLeader
 * @property {SwuGameLogEntry[]} log
 * @property {number} startTime
 * @property {number} endTime
 * @property {boolean} ended

 * @typedef  LogType Claim | Damage | Heal | Initiative | EpicAction | GameStart | Reset | RoundEnd | Win
 * @typedef  Player top | bottom | none

 * @typedef {Object} SwuGameLogEntry
 * @property {string} message
 * @property {Player} player
 * @property {LogType} type
 * @property {number} value
 * @property {number} round
 * @property {number} timestamp
 * @property {number} timeInGame

 @typedef {Object} StateUiToggle
 @property {boolean} show
 @property {Player} player
 
 
 * @typedef {Object} StateUi
 * @property {StateUiToggle} showSettings
 * @property {StateUiToggle} showBaseModal
 * @property {StateUiToggle} showLeaderModal
 * @property {StateUiToggle} showPickWinnerModal
 * @property {StateUiToggle} showLog
 * @property {StateUiToggle} showInitiative
 
 * @typedef {Object} SwucState
 * @property {Player} top
 * @property {Player} bottom
 * @property {StateUi} ui
 * @property {StateSettings} settings
 * @property {StateGame | undefined} currentGame
 * @property {StateGame[]} games
 */ /**
 * @name LoadGames
 * @returns {Game[]} logs
 */ function $e809d279eda62738$export$db7021829e9de79c() {
    const savedGames = localStorage.getItem("savedGames");
    /** @type {Game[]} */ let games = [];
    if (savedGames) games = JSON.parse(savedGames);
    return games;
}


const $251c1d00443185ab$export$969a517631b92a15 = {
    top: "top",
    bottom: "bottom",
    none: "none"
};
const $251c1d00443185ab$export$50918c26e7741530 = {
    villain: "#111",
    heroism: "#f2f2f2",
    vigilance: "#2298D2",
    aggression: "#C31924",
    cunning: "#F0BA32",
    command: "#00A44D",
    neutral: "#CCCCCC"
};


const $b786174071d94ba7$export$1144cef7e5483214 = {
    startTimer: "start_timer",
    stopTimer: "stop_timer",
    resetTimer: "reset_timer"
};
const $b786174071d94ba7$export$9ec629e2b5a69446 = {
    resetBase: "reset_base",
    resetAll: "reset_all_bases",
    setBase: "set_base",
    setLeader: "set_leader",
    resetLeader: "reset_leader"
};
/**
 * @name resetBaseReducer
 * @param {SwucState} state
 * @param {"top" | "bottom"} payload
 * @return {SwucState}
 */ function $b786174071d94ba7$var$resetBaseReducer(state, payload) {
    if (payload !== (0, $251c1d00443185ab$export$969a517631b92a15).top && payload !== (0, $251c1d00443185ab$export$969a517631b92a15).bottom) {
        console.error("Invalid payload", payload);
        return state;
    }
    if (state[payload] === undefined) {
        console.error("Invalid state", state);
        return state;
    }
    const newState = {
        ...state
    };
    newState[payload].base = undefined;
    return newState;
}
/**
 * @name resetAllReducer
 * @param {SwucState} state
 * @return {SwucState}
 */ function $b786174071d94ba7$var$resetAllReducer(state) {
    const newState = {
        ...state
    };
    newState.top.base = undefined;
    newState.top.leader = undefined;
    newState.top.remainingHp = 0;
    newState.bottom.base = undefined;
    newState.bottom.leader = undefined;
    newState.bottom.remainingHp = 0;
    newState.currentGame = undefined;
    return newState;
}
/**
 *  @name setBaseReducer
 * @param {SwucState} state
 * @param {{base, string}} payload
 * @return {SwucState}
 */ function $b786174071d94ba7$var$setBaseReducer(state, { base: base, player: player }) {
    if (player !== (0, $251c1d00443185ab$export$969a517631b92a15).top && player !== (0, $251c1d00443185ab$export$969a517631b92a15).bottom) {
        console.error("Invalid payload", {
            base: base,
            player: player
        });
        return state;
    }
    if (state[player] === undefined) {
        console.error("Invalid state", state);
        return state;
    }
    const newState = {
        ...state
    };
    newState[player].base = base;
    newState[player].remainingHp = base.hp;
    newState.ui.showBaseModal.show = false;
    newState.ui.showBaseModal.player = "none";
    return newState;
}
/**
 * @name setLeaderReducer
 * @param {SwucState} state
 * @param {{leader, string}} payload
 * @return {SwucState}
 */ function $b786174071d94ba7$var$setLeaderReducer(state, { leader: leader, player: player }) {
    console["log"]("\uD83D\uDC35: ", leader, player);
    if (player !== "top" && player !== "bottom") {
        console.error("Invalid payload", {
            leader: leader,
            player: player
        });
        return state;
    }
    if (state[player] === undefined) {
        console.error("Invalid state", state);
        return state;
    }
    const newState = {
        ...state
    };
    newState[player].leader = leader;
    return newState;
}
function $b786174071d94ba7$var$resetLeaderReducer(state, player) {
    if (player !== "top" && player !== "bottom") {
        console.error("Invalid payload", player);
        return state;
    }
    if (state[player] === undefined) {
        console.error("Invalid state", state);
        return state;
    }
    const newState = {
        ...state
    };
    newState[player].leader = undefined;
    return newState;
}
const $b786174071d94ba7$export$c5f23f1f18cf6589 = {
    [$b786174071d94ba7$export$9ec629e2b5a69446.resetBase]: $b786174071d94ba7$var$resetBaseReducer,
    [$b786174071d94ba7$export$9ec629e2b5a69446.setBase]: $b786174071d94ba7$var$setBaseReducer,
    [$b786174071d94ba7$export$9ec629e2b5a69446.setLeader]: $b786174071d94ba7$var$setLeaderReducer,
    [$b786174071d94ba7$export$9ec629e2b5a69446.resetLeader]: $b786174071d94ba7$var$resetLeaderReducer,
    [$b786174071d94ba7$export$9ec629e2b5a69446.resetAll]: $b786174071d94ba7$var$resetAllReducer
};



/**
 * @type {{add_user: string}}
 */ const $32a6954a8dd0c1f7$export$6090639ede23396f = {
    toggleSelectBase: "toggle_select_base",
    toggleSettings: "toggle_settings",
    toggleSelectLeader: "toggle_select_leader",
    togglePickWinnerModal: "toggle_winner_modal",
    toggleLog: "toggle_log",
    toggleInitiativeModal: "toggle_initiative_modal"
};
/**
 * @name toggleSelectBaseReducer
 * @param {SwucState} state
 * @param {StateUiToggle} payload
 * @return {SwucState}
 */ function $32a6954a8dd0c1f7$var$toggleSelectBaseReducer(state, { player: player = "none", show: show = false }) {
    const newState = {
        ...state
    };
    newState.ui.showBaseModal = {
        player: player,
        show: show
    };
    return newState;
}
/**
 * @name toggleSettingsReducer
 * @param {SwucState} state
 * @param {StateUiToggle} payload
 * @return {SwucState}
 */ function $32a6954a8dd0c1f7$var$toggleSettingsReducer(state, { player: player = "none", show: show = false }) {
    const newState = {
        ...state
    };
    newState.ui.showSettings = {
        player: player,
        show: show
    };
    return newState;
}
/**
 * @name toggleLogReducer
 * @param {SwucState} state
 * @param {StateUiToggle} payload
 * @return {SwucState}
 */ function $32a6954a8dd0c1f7$var$toggleLogReducer(state, { player: player, show: show }) {
    const newState = {
        ...state
    };
    newState.ui.showLog = {
        player: player,
        show: show
    };
    return newState;
}
function $32a6954a8dd0c1f7$export$576415e464c219f5(state, { player: player, show: show }) {
    const newState = {
        ...state
    };
    newState.ui.showInitiative = {
        player: "bottom",
        show: show
    };
    return newState;
}
/**
 *  @name toggleSelectLeaderReducer
 * @param {SwucState} state
 * @param {StateUiToggle} payload
 * @return {SwucState}
 */ function $32a6954a8dd0c1f7$var$toggleSelectLeaderReducer(state, { player: player = "none", show: show = false }) {
    const newState = {
        ...state
    };
    newState.ui.showLeaderModal = {
        player: player,
        show: show
    };
    return newState;
}
/**
 *  @name toggleSelectLeaderReducer
 * @param {SwucState} state
 * @param {StateUiToggle} payload
 * @return {SwucState}
 */ function $32a6954a8dd0c1f7$var$togglePickWinnerModalReducer(state, { player: player = "none", show: show = false }) {
    const newState = {
        ...state
    };
    newState.ui.showPickWinnerModal = {
        player: player,
        show: show
    };
    return newState;
}
const $32a6954a8dd0c1f7$export$94c125d2fb12f03a = {
    [$32a6954a8dd0c1f7$export$6090639ede23396f.toggleSelectBase]: $32a6954a8dd0c1f7$var$toggleSelectBaseReducer,
    [$32a6954a8dd0c1f7$export$6090639ede23396f.toggleSettings]: $32a6954a8dd0c1f7$var$toggleSettingsReducer,
    [$32a6954a8dd0c1f7$export$6090639ede23396f.toggleSelectLeader]: $32a6954a8dd0c1f7$var$toggleSelectLeaderReducer,
    [$32a6954a8dd0c1f7$export$6090639ede23396f.togglePickWinnerModal]: $32a6954a8dd0c1f7$var$togglePickWinnerModalReducer,
    [$32a6954a8dd0c1f7$export$6090639ede23396f.toggleLog]: $32a6954a8dd0c1f7$var$toggleLogReducer,
    [$32a6954a8dd0c1f7$export$6090639ede23396f.toggleInitiativeModal]: $32a6954a8dd0c1f7$export$576415e464c219f5
};


const $4c2c1f9d3291d290$export$294ff5f8632c1e8f = {
    start: "start_game",
    end: "end_game",
    rematch: "rematch_game",
    damage: "damage_base",
    heal: "heal_base",
    claimInitiative: "claim_initiative",
    useEpicAction: "use_epic_action",
    setWinner: "set_winner"
};
const $4c2c1f9d3291d290$var$LogTypes = {
    damage: "Damage",
    heal: "Heal",
    initiative: "Initiative",
    epicAction: "EpicAction",
    gameStart: "GameStart",
    gameEnd: "GameEnd"
};
/**
 * @name addLogReducer
 * @param {SwucState} state
 * @param {string} message
 * @param {string} type
 * @param {"top" | "bottom"} player
 * @param {number} amount
 * @return {SwucState}
 */ function $4c2c1f9d3291d290$var$addLogReducer(state, { message: message, type: type, player: player, amount: amount = 0 }) {
    const newState = {
        ...state
    };
    newState.currentGame.log.push({
        player: player,
        message: message,
        type: type,
        amount: amount,
        timestamp: Date.now(),
        timeInGame: Date.now() - newState.currentGame.startTime
    });
    return newState;
}
/**
 * @name setWinnerReducer
 * @param {SwucState} state
 * @param {"top" | "bottom"} player
 * @param {string} reason
 * @return {SwucState}
 */ function $4c2c1f9d3291d290$var$setWinnerReducer(state, { player: player, reason: reason }) {
    let newState = {
        ...state
    };
    newState.currentGame.ended = true;
    newState.currentGame.winner = player;
    newState.currentGame.endTime = Date.now();
    newState.games.push(newState.currentGame);
    newState.ui.showPickWinnerModal = {
        player: "none",
        show: false
    };
    newState = $4c2c1f9d3291d290$var$addLogReducer(newState, {
        message: reason,
        type: $4c2c1f9d3291d290$var$LogTypes.gameEnd,
        player: player
    });
    (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)($4c2c1f9d3291d290$export$294ff5f8632c1e8f.end);
    return newState;
}
/**
 * @name startGameReducer
 * @param {SwucState} state
 * @return {SwucState}
 */ function $4c2c1f9d3291d290$var$startGameReducer(state) {
    const newState = {
        ...state
    };
    newState.currentGame = {
        rounds: 1,
        topBase: newState.top,
        bottomBase: newState.bottom,
        log: [
            {
                message: "Game started",
                timestamp: Date.now(),
                type: $4c2c1f9d3291d290$var$LogTypes.gameStart,
                timeInGame: 0,
                player: "none"
            }
        ],
        startTime: Date.now(),
        ended: false
    };
    return (0, $32a6954a8dd0c1f7$export$576415e464c219f5)(newState, {
        player: "bottom",
        show: true
    });
}
function $4c2c1f9d3291d290$var$endGameReducer(state) {
    let newState = {
        ...state
    };
    newState = $4c2c1f9d3291d290$var$addLogReducer(newState, {
        message: `Gave over`,
        type: $4c2c1f9d3291d290$var$LogTypes.damage,
        player: "none"
    });
    newState.currentGame.ended = true;
    newState.currentGame.endTime = Date.now();
    newState.games.push(newState.currentGame);
    return newState;
}
/**
 * @name rematchGameReducer
 * @param {SwucState} state
 * @return {SwucState}
 */ function $4c2c1f9d3291d290$var$rematchGameReducer(state) {
    const newState = {
        ...state
    };
    newState.currentGame = {
        rounds: 1,
        topBase: newState.top,
        topLeader: newState.top.leader,
        bottomBase: newState.bottom,
        bottomLeader: newState.bottom.leader,
        log: [
            {
                message: "Game started",
                timestamp: Date.now(),
                type: $4c2c1f9d3291d290$var$LogTypes.gameStart,
                timeInGame: 0,
                player: "none"
            }
        ],
        startTime: Date.now(),
        ended: false
    };
    const loser = state.currentGame.winner === "top" ? "bottom" : "top";
    newState.top.remainingHp = newState.top.base.hp;
    newState.bottom.remainingHp = newState.bottom.base.hp;
    newState.top.hasUsedEpicAction = false;
    newState.bottom.hasUsedEpicAction = false;
    newState[loser].hasInitiative = true;
    newState[state.currentGame.winner].hasInitiative = false;
    return newState;
}
/**
 * @name doDamage
 * @param {SwucState} state
 * @param {"top" | "bottom"} player
 * @param {number} amount
 * @return {SwucState}
 */ function $4c2c1f9d3291d290$var$doDamage(state, { player: player, amount: amount }) {
    if (player !== "top" && player !== "bottom") {
        console.error("Invalid payload", player);
        return state;
    }
    if (state[player] === undefined) {
        console.error("Invalid state", state);
        return state;
    }
    let newState = {
        ...state
    };
    newState[player].remainingHp -= amount;
    if (newState[player].remainingHp <= 0) {
        const opponent = player === "top" ? "bottom" : "top";
        newState[player].remainingHp = 0;
        newState.currentGame.ended = true;
        newState.currentGame.winner = opponent;
        newState.currentGame.endTime = Date.now();
        newState.games.push(newState.currentGame);
        (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)($4c2c1f9d3291d290$export$294ff5f8632c1e8f.end);
    }
    newState = $4c2c1f9d3291d290$var$addLogReducer(newState, {
        message: `Deal ${amount} damage. (${newState[player].remainingHp + "/" + newState[player].base.hp} hp)`,
        type: $4c2c1f9d3291d290$var$LogTypes.damage,
        amount: amount,
        player: player
    });
    return newState;
}
/**
 * @name healDamage
 * @param {SwucState} state
 * @param {"top" | "bottom"} player
 * @param {number} amount
 * @return {SwucState}
 */ function $4c2c1f9d3291d290$var$healDamage(state, { player: player, amount: amount }) {
    if (player !== "top" && player !== "bottom") {
        console.error("Invalid payload", player);
        return state;
    }
    if (state[player] === undefined) {
        console.error("Invalid state", state);
        return state;
    }
    let newState = {
        ...state
    };
    newState[player].remainingHp += amount;
    if (newState[player].remainingHp > newState[player].base.hp) newState[player].remainingHp = newState[player].base.hp;
    newState = $4c2c1f9d3291d290$var$addLogReducer(newState, {
        message: `Heal ${amount} damage (${newState[player].remainingHp + "/" + newState[player].base.hp} hp)`,
        type: $4c2c1f9d3291d290$var$LogTypes.heal,
        amount: amount,
        player: player
    });
    return newState;
}
/**
 * @name claimInitiative
 * @param {SwucState} state
 * @param player
 * @return {SwucState}
 */ function $4c2c1f9d3291d290$var$claimInitiative(state, player) {
    if (player !== "top" && player !== "bottom") {
        console.error("Invalid payload", player);
        return state;
    }
    if (state[player] === undefined) {
        console.error("Invalid state", state);
        return state;
    }
    const opponent = player === "top" ? "bottom" : "top";
    let newState = {
        ...state
    };
    newState[player].hasInitiative = true;
    newState[opponent].hasInitiative = false;
    let logMessage = `Claims initiative`;
    newState = $4c2c1f9d3291d290$var$addLogReducer(newState, {
        message: logMessage,
        type: $4c2c1f9d3291d290$var$LogTypes.initiative,
        player: player
    });
    return newState;
}
/**
 * @name useEpicAction
 * @param {SwucState} state
 * @param player
 * @return {SwucState}
 */ function $4c2c1f9d3291d290$var$useEpicAction(state, player) {
    if (player !== "top" && player !== "bottom") {
        console.error("Invalid payload", player);
        return state;
    }
    if (state[player] === undefined) {
        console.error("Invalid state", state);
        return state;
    }
    if (state[player].base.epicAction === undefined) {
        console.error("No epic action available", player);
        return state;
    }
    let newState = {
        ...state
    };
    newState[player].hasUsedEpicAction = !newState[player].hasUsedEpicAction;
    newState = $4c2c1f9d3291d290$var$addLogReducer(newState, {
        message: `Uses epic action`,
        type: $4c2c1f9d3291d290$var$LogTypes.epicAction,
        player: player
    });
    return newState;
}
const $4c2c1f9d3291d290$export$8903d0fb2f5f54db = {
    [$4c2c1f9d3291d290$export$294ff5f8632c1e8f.start]: $4c2c1f9d3291d290$var$startGameReducer,
    [$4c2c1f9d3291d290$export$294ff5f8632c1e8f.rematch]: $4c2c1f9d3291d290$var$rematchGameReducer,
    [$4c2c1f9d3291d290$export$294ff5f8632c1e8f.damage]: $4c2c1f9d3291d290$var$doDamage,
    [$4c2c1f9d3291d290$export$294ff5f8632c1e8f.heal]: $4c2c1f9d3291d290$var$healDamage,
    [$4c2c1f9d3291d290$export$294ff5f8632c1e8f.claimInitiative]: $4c2c1f9d3291d290$var$claimInitiative,
    [$4c2c1f9d3291d290$export$294ff5f8632c1e8f.useEpicAction]: $4c2c1f9d3291d290$var$useEpicAction,
    [$4c2c1f9d3291d290$export$294ff5f8632c1e8f.setWinner]: $4c2c1f9d3291d290$var$setWinnerReducer,
    [$4c2c1f9d3291d290$export$294ff5f8632c1e8f.end]: $4c2c1f9d3291d290$var$endGameReducer
};



/**
 * @type {{string: function(SwucState, string=): SwucState}}
 */ let $cfdf6f1829f6520f$var$_reducers = {
    initState: (state)=>state
};
function $cfdf6f1829f6520f$export$81d9893b8b9b8aba(newReducer) {
    $cfdf6f1829f6520f$var$_reducers = {
        ...$cfdf6f1829f6520f$var$_reducers,
        ...newReducer
    };
}
function $cfdf6f1829f6520f$export$cf167d5dfe57ae0e() {
    return {
        ...$cfdf6f1829f6520f$var$_reducers
    };
}
function $cfdf6f1829f6520f$export$34dc4cbf9ab25369() {
    $cfdf6f1829f6520f$export$81d9893b8b9b8aba((0, $b786174071d94ba7$export$c5f23f1f18cf6589));
    $cfdf6f1829f6520f$export$81d9893b8b9b8aba((0, $4c2c1f9d3291d290$export$8903d0fb2f5f54db));
    $cfdf6f1829f6520f$export$81d9893b8b9b8aba((0, $32a6954a8dd0c1f7$export$94c125d2fb12f03a));
}


function $49a3b7170c6ecdc1$export$90290f6344692b04() {
    if (window.swucState !== undefined) return $49a3b7170c6ecdc1$export$c34e6bd86d7a1d50(window.swucState);
    return $49a3b7170c6ecdc1$export$8d6594f2ef703eca();
}
function $49a3b7170c6ecdc1$export$c34e6bd86d7a1d50(state) {
    return JSON.parse(JSON.stringify(state));
}
/**
 * @name updateState
 * @param detail
 */ function $49a3b7170c6ecdc1$var$updateState({ detail: detail }) {
    const { action: action = "", payload: payload } = detail;
    console.log("Action", action, payload);
    const reducers = (0, $cfdf6f1829f6520f$export$cf167d5dfe57ae0e)();
    const oldState = $49a3b7170c6ecdc1$export$c34e6bd86d7a1d50(window.swucState);
    const newState = $49a3b7170c6ecdc1$export$c34e6bd86d7a1d50(window.swucState);
    if (reducers[action]) {
        const updatedState = reducers[action](newState, payload);
        window.swucState = $49a3b7170c6ecdc1$export$c34e6bd86d7a1d50(updatedState);
        //saveToLocalStorage(STATE_KEY, window.swucState);
        document.body.dispatchEvent(new CustomEvent("stateChanged", {
            detail: {
                state: window.swucState,
                old: oldState
            }
        }));
    }
}
const $49a3b7170c6ecdc1$var$STATE_KEY = "swuc_state";
function $49a3b7170c6ecdc1$export$8d6594f2ef703eca() {
    document.body.addEventListener("updateState", $49a3b7170c6ecdc1$var$updateState);
    //const localStorageState = getFromLocalStorage(STATE_KEY);
    /** @type {SwucState} */ const state = {
        games: (0, $e809d279eda62738$export$db7021829e9de79c)(),
        currentGame: undefined,
        top: {
            name: "Top Player",
            leader: undefined,
            base: undefined,
            remainingHp: 30,
            hasInitiative: false,
            hasUsedEpicAction: false
        },
        bottom: {
            name: "Bottom Player",
            leader: undefined,
            base: undefined,
            remainingHp: 30,
            hasInitiative: false,
            hasUsedEpicAction: false
        },
        settings: {
            countUp: true
        },
        ui: {
            showSettings: {
                show: false,
                player: "none"
            },
            showBaseModal: {
                show: false,
                player: "none"
            },
            showLeaderModal: {
                show: false,
                player: "none"
            },
            showPickWinnerModal: {
                show: false,
                player: "none"
            },
            showLog: {
                show: false,
                player: "none"
            },
            showInitiative: {
                show: false,
                player: "bottom"
            }
        }
    };
    window.swucState = state;
    $49a3b7170c6ecdc1$export$12f655127a1457b7("initState", state);
    return state;
}
function $49a3b7170c6ecdc1$export$12f655127a1457b7(action, payload) {
    document.body.dispatchEvent(new CustomEvent("updateState", {
        detail: {
            action: action,
            payload: payload
        }
    }));
}
function $49a3b7170c6ecdc1$export$5dc36268de8a8ad4(listener) {
    document.body.addEventListener("stateChanged", listener);
}
function $49a3b7170c6ecdc1$export$e9feafb5b7d09568(action, listener) {
    document.body.addEventListener("updateState", (e)=>{
        if (e.detail.action === action) listener(e.detail.payload);
    });
}
function $49a3b7170c6ecdc1$export$c1b87ce11f9130b(listener) {
    document.body.removeEventListener("stateChanged", listener);
}


class $d6c55283e5567e0f$export$c7bac36d9db821bc extends HTMLElement {
    state;
    constructor(){
        super();
        this.state = (0, $49a3b7170c6ecdc1$export$90290f6344692b04)();
        this.registerStateEventListeners();
    }
    render() {
        console.info("\uD83E\uDDD9\u200D\u2642\uFE0F[ConnectedHTMLElement] render");
    }
    updateStateListener(e) {
        const oldState = {
            ...this.state
        };
        // console["log"](
        //   "🐵 ConnectedHTMLElement: updateStateListener: ",
        //   e.detail.state,
        //   e.detail.old,
        //   oldState
        // );
        this.state = e.detail.state;
        this.stateUpdated(this.state, oldState);
    }
    registerStateEventListeners() {
        (0, $49a3b7170c6ecdc1$export$5dc36268de8a8ad4)(this.updateStateListener.bind(this));
    }
    stateUpdated(newState, oldState) {
        console.info("\uD83E\uDDD9\u200D\u2642\uFE0F[ConnectedHTMLElement] stateUpdated", newState, oldState);
    }
    disconnectedCallback() {
        // unregister events
        (0, $49a3b7170c6ecdc1$export$c1b87ce11f9130b)(this.updateStateListener.bind(this));
    }
}




class $1f2ef80fd5e2c367$export$432afc5e995117f8 extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    static observedAttributes = [
        "player"
    ];
    constructor(){
        super();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        const player = this.getAttribute("player");
        const div = this.querySelector(`#${player}-start-match`);
        // Bases are selected, but the game has not started yet
        if (newState.top.base !== undefined && newState.bottom.base !== undefined && newState.currentGame === undefined) {
            div.classList.remove("hidden");
            const btn = this.querySelector(`#${player}-start-match-btn`);
            if (btn) btn.disabled = false;
            return;
        }
        // A game has been started
        if (newState.currentGame !== undefined && oldState.currentGame === undefined) div.classList.add("hidden");
    }
    handleButtonClick(e) {
        e.preventDefault();
        (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $4c2c1f9d3291d290$export$294ff5f8632c1e8f).start);
    }
    registerEvents() {
        const player = this.getAttribute("player");
        const button = this.querySelector(`#${player}-start-match-btn`);
        if (button) button.addEventListener("click", this.handleButtonClick);
    }
    render() {
        const player = this.getAttribute("player");
        this.innerHTML = `
        <div
        class="z-[5] h-[80px] max-w-[500px] bottom-[25%] p-2 flex flex-row justify-center items-center absolute w-full hidden"
        id="${player}-start-match"
      >
        <button
          type="button"
          class="btn btn-success btn-xl flex flex-col w-full btn-primary font-bold text-xl text-neutral"
          id="${player}-start-match-btn"
        >
          <span>Start match!</span>
        </button>
      </div>`;
    }
    connectedCallback() {
        this.render();
        this.registerEvents();
    }
    disconnectedCallback() {
        const player = this.getAttribute("player");
        const button = this.querySelector(`#${player}-start-match-btn`);
        if (button) button.removeEventListener("click", this.handleButtonClick);
    }
}





class $1c52bf34e3765fde$export$e30d303f4ee9312e extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    static observedAttributes = [
        "player"
    ];
    constructor(){
        super();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        if (oldState.currentGame === undefined && newState.currentGame !== undefined || newState.currentGame?.ended !== oldState.currentGame?.ended) //only render when a game has started or ended
        this.render();
    }
    registerEvents() {
        const player = this.getAttribute("player");
        const buttons = this.querySelectorAll("button");
        buttons.forEach((b)=>{
            b.addEventListener("click", (e)=>{
                e.preventDefault();
                const amount = Number(b.dataset.amount);
                if (b.classList.contains("btn-damage")) {
                    if (this.state.currentGame?.ended) return;
                    (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $4c2c1f9d3291d290$export$294ff5f8632c1e8f).damage, {
                        player: player,
                        amount: amount
                    });
                } else if (b.classList.contains("btn-heal")) {
                    if (this.state.currentGame?.ended) return;
                    if (this.state[player].remainingHp === this.state[player].base.hp) return;
                    (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $4c2c1f9d3291d290$export$294ff5f8632c1e8f).heal, {
                        player: player,
                        amount: amount
                    });
                }
            });
        });
    }
    render() {
        const player = this.getAttribute("player");
        const gameEnded = this.state.currentGame?.ended;
        if (this.state.currentGame === undefined) {
            this.innerHTML = ``;
            return;
        }
        this.innerHTML = `
         <div
          class="p-2 bg-neutral absolute left-0 top-0 w-full z-[45] height-[114px]"
          id="counter"
        >
          <div
            class="flex flex-row place-content-between ${gameEnded ? "hidden" : ""}"
            id="counter-toolbar"
          >
            <div class="flex flex-row">
              <button
                class="btn action-btn btn-heal mr-1"
                id="counter-increment-1"
                data-amount="1"
                ${gameEnded ? "disabled" : ""}
                type="button"
                title="Heal 1"
              >
                <img
                  alt="Medical cross"
                  height="64"
                  src="/assets/icons/heal-1.svg"
                  width="64"
                />
              </button>
              <button
                class="btn action-btn btn-heal mr-1"
                id="counter-increment-3"
                data-amount="3"
                ${gameEnded ? "disabled" : ""}
                type="button"
                title="Heal 3"
              >
                <img
                  alt="Medical cross"
                  height="64"
                  src="/assets/icons/heal-3.svg"
                  width="64"
                />
              </button>
              <button
                class="btn action-btn btn-heal"
                id="counter-increment-5"
                data-amount="5"
                ${gameEnded ? "disabled" : ""}
                type="button"
                title="Heal 5"
              >
                <img
                  alt="Medical cross"
                  height="64"
                  src="/assets/icons/heal-5.svg"
                  width="64"
                />
              </button>
            </div>
            <div class="flex flex-row ${gameEnded ? "hidden" : ""}">
              <button
                class="btn action-btn btn-damage"
                id="counter-decrement-5"
                data-amount="5"
                ${gameEnded ? "disabled" : ""}
                type="button"
                title="Deal 5 damage"
              >
                <img
                  alt="Explosion icon"
                  height="64"
                  src="/assets/icons/damage-5.svg"
                  width="64"
                />
              </button>
              <button
                class="btn action-btn btn-damage"
                id="counter-decrement-3"
                data-amount="3"
                ${gameEnded ? "disabled" : ""}
                type="button"
                title="Deal 3 damage"
              >
                <img
                  alt="Explosion icon"
                  height="64"
                  src="/assets/icons/damage-3.png"
                  width="64"
                />
              </button>
              <button
                class="btn action-btn btn-damage"
                id="counter-decrement-1"
                data-amount="1"
                ${gameEnded ? "disabled" : ""}
                type="button"
                title="Deal 1 damage"
              >
                <img
                  alt="Explosion icon"
                  height="64"
                  src="/assets/icons/damage-1.svg"
                  width="64"
                />
              </button>
            </div>
          </div>
          <game-timer player="${player}"></game-timer>
        </div>`;
        this.registerEvents();
    }
}



class $788451c9c961b342$export$8efd160a88d6fdc7 extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    static observedAttributes = [
        "player"
    ];
    constructor(){
        super();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        this.render();
    }
    render() {
        const player = this.getAttribute("player");
        const opponent = player === "top" ? "bottom" : "top";
        if (this.state.currentGame === undefined) {
            this.innerHTML = "";
            return;
        }
        const value = this.state[player] !== undefined && this.state[player].base !== undefined ? `${this.state[player].base.hp - this.state[player].remainingHp}` : `0`;
        const opponentValue = this.state[opponent] !== undefined && this.state[opponent].base !== undefined ? `${this.state[opponent].base.hp - this.state[opponent].remainingHp}` : "0";
        this.innerHTML = `
    <div class="counter-container absolute bottom-[calc(25vh-164px)] flex flex-col items-center justify-start w-full">
      <h1 class="counter-h1 m-0 heading-font">${value}</h1>
      <div class="counter-container flex flex-row items-center justify-center w-full">
        <span class="vs">vs.</span> <span class="opponent">${opponentValue}</span>
      </div>
    </div>`;
    }
    connectedCallback() {
        this.render();
    }
}





class $f1bfe6681c8b0c97$export$6b437c5bf6e35b26 extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    static observedAttributes = [
        "player"
    ];
    constructor(){
        super();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        const player = this.getAttribute("player");
        const baseSelected = this.state[player].base !== undefined;
        const btn = this.querySelector(`#${player}-open-modal`);
        if (baseSelected) btn.querySelector("p").innerText = "Change base";
        else btn.querySelector("p").innerText = "Select base";
        if (newState.currentGame) btn.classList.add("hidden");
        if (!newState.currentGame) btn.classList.remove("hidden");
    }
    registerElementEvents() {
        const player = this.getAttribute("player");
        const openModalBtn = this.querySelector(`#${player}-open-modal`);
        openModalBtn.addEventListener("click", ()=>{
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $32a6954a8dd0c1f7$export$6090639ede23396f).toggleSelectBase, {
                show: true,
                player: player
            });
        });
        const openLeaderModalBtn = this.querySelector("#open-leader-modal");
        if (openLeaderModalBtn === null) return;
        openLeaderModalBtn.addEventListener("click", ()=>{
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $32a6954a8dd0c1f7$export$6090639ede23396f).toggleSelectLeader, {
                show: true,
                player: player
            });
        });
    }
    render() {
        const player = this.getAttribute("player");
        this.innerHTML = `<div class="w-full h-full flex flex-col items-center justify-center">
        <button
          class="btn btn-neutral btn-xl btn-wide flex flex-row items-center justify-center font-bold text-xl text-neutral-content mt-4"
            id="${player}-open-modal">
            <p class="mr-1 ">Select base</p>
            <img src="/assets/icons/deathstar.svg" width="32" height="32" alt="Death star" class="rounded-full bg-neutral p-1" />
          </button
        </button>
      </div>`;
    }
    connectedCallback() {
        this.render();
        this.registerElementEvents();
    }
    dispatchEvent(event) {
        return false;
    }
}



class $a6dad443d03ae1af$export$1e1e5f57917ff9ab extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    static observedAttributes = [
        "player"
    ];
    constructor(){
        super();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        this.render();
    }
    render() {
        const player = this.getAttribute("player");
        if (this.state.currentGame === undefined || this.state.currentGame.winner === undefined || this.state.currentGame.winner !== player) {
            this.innerHTML = "";
            return;
        }
        this.innerHTML = `
      <div
        class="bottom-[30px] justify-center items-center flex-col w-full h-auto flex z-50 absolute"
        id="win-overlay"
      >
        <h2 class="text-shadow top-0 font-extrabold text-center absolute font-normal text-4xl">
          Congratulations!<br />You win!
        </h2>
        <img
          alt="You win"
          height="199"
          loading="lazy"
          src="/assets/img/winner-medal.png"
          width="150"
        />
      </div>
      `;
    }
    connectedCallback() {
        this.render();
    }
}



class $01d35cce215b0922$export$19239e31aef9944c extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    static observedAttributes = [
        "player"
    ];
    constructor(){
        super();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        this.render();
    }
    render() {
        const player = this.getAttribute("player");
        if (this.state.currentGame === undefined || this.state.currentGame.winner === undefined || this.state.currentGame.winner === player) {
            this.innerHTML = "";
            return;
        }
        this.innerHTML = `
          <img
          alt="You lose"
          height="400"
          id="loss-overlay"
          loading="lazy"
          src="/assets/img/loss.png"
          width="557"
          class="absolute bottom-0 left-0 w-full h-auto z-10"
        />
        `;
    }
    connectedCallback() {
        this.render();
    }
}





class $7886e5e512d2b761$export$870266edbe4a201b extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    static observedAttributes = [
        "player"
    ];
    constructor(){
        super();
        this.registerActionListeners();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        const player = this.getAttribute("player");
        if (//newState[player].hasInitiative !== oldState[player].hasInitiative ||
        oldState.currentGame === undefined && newState.currentGame !== undefined || newState.currentGame !== undefined && newState.currentGame?.ended === true || newState.currentGame?.ended === false && oldState.currentGame?.ended === true) this.render();
    }
    registerActionListeners() {
        (0, $49a3b7170c6ecdc1$export$e9feafb5b7d09568)((0, $4c2c1f9d3291d290$export$294ff5f8632c1e8f).claimInitiative, (player)=>{
            const isOpponent = player !== this.getAttribute("player");
            if (isOpponent) this.renderLoseInitiative();
            else this.renderClaimInitiative();
        });
    }
    registerElementEvents() {
        const player = this.getAttribute("player");
        const button = this.querySelector("button");
        button.addEventListener("click", ()=>{
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $4c2c1f9d3291d290$export$294ff5f8632c1e8f).claimInitiative, player);
        });
    }
    renderLoseInitiative() {
        const button = this.querySelector("button");
        button.classList.remove("opacity-100");
        button.classList.add("opacity-50");
    }
    renderClaimInitiative() {
        const button = this.querySelector("button");
        button.classList.remove("opacity-50");
        button.classList.add("opacity-100");
        button.classList.add("flip");
        setTimeout(()=>{
            button.classList.remove("flip");
        }, 600);
    }
    render() {
        const player = this.getAttribute("player");
        const baseSelected = this.state[player].base !== undefined;
        const tokenHidden = this.state.currentGame !== undefined && this.state.currentGame.ended || this.state.currentGame === undefined;
        if (tokenHidden) {
            this.innerHTML = "";
            return;
        }
        this.innerHTML = `
          <button class="cursor-pointer left-0 bottom-12 absolute bg-transparent border-0 z-10 ${this.state[player].hasInitiative ? "opacity-100" : "opacity-50"}">
            <span class="hidden">Claim<br />Initiative</span>
            <img
              alt="Initiative counter"
              height="194"
              id="top-initiative"
              loading="lazy"
              src="/assets/img/initiative-counter.png"
              width="204"
              class="w-[90px] h-auto"
            />
          </button>
        `;
        this.registerElementEvents();
    }
    connectedCallback() {
    //this.render();
    }
}





class $467fdd11151b9461$export$a6af1aae51e188bd extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    static observedAttributes = [
        "player"
    ];
    constructor(){
        super();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        const player = this.getAttribute("player");
        const button = this.querySelector("#epic-action-btn");
        if (!button) return;
        //player has used their epic action
        if (newState[player].hasUsedEpicAction !== oldState[player].hasUsedEpicAction) button.classList.remove("opacity-50");
        // New game is on, remove hidden
        if (oldState.currentGame === undefined && newState.currentGame !== undefined) {
            button.classList.add("opacity-50");
            button.classList.remove("hidden");
        }
        // Rematch, remove hidden
        if (oldState.currentGame !== undefined && oldState.currentGame.ended === true && newState.currentGame !== undefined && newState.currentGame.ended === false) {
            button.classList.add("opacity-50");
            button.classList.remove("hidden");
        }
        // Game is over, add hidden
        if (newState.currentGame !== undefined && newState.currentGame.ended === true) button.classList.add("hidden");
    }
    registerElementEvents() {
        const player = this.getAttribute("player");
        const button = this.querySelector("button");
        button.addEventListener("click", ()=>{
            button.classList.add("spin");
            setTimeout(()=>{
                button.classList.remove("spin");
                (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $4c2c1f9d3291d290$export$294ff5f8632c1e8f).useEpicAction, player);
            }, 600);
        });
    }
    render() {
        const gameOver = this.state.currentGame !== undefined && this.state.currentGame.ended;
        if (gameOver) {
            this.innerHTML = "";
            return;
        }
        this.innerHTML = `
        <button
          class=" opacity-50 absolute right-[10px] bottom-[55px] z-10 bg-none border-none hidden"
          id="epic-action-btn"
        >
          <span class="hidden">Epic action</span>
          <img
            alt="Epic action"
            class=" w-[60px] h-auto"
            height="511"
            id="top-epic-action"
            loading="lazy"
            src="/assets/img/epic-action.png"
            width="410"
          />
        </button>`;
        this.registerElementEvents();
    }
    connectedCallback() {
        this.render();
    }
    dispatchEvent(event) {
        return false;
    }
}




class $166120334c418ac7$export$6c78f30ecf8eb3f2 extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    static observedAttributes = [
        "player"
    ];
    constructor(){
        super();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        const player = this.getAttribute("player");
        if (newState[player].base !== oldState[player].base && newState[player].base !== undefined) {
            const img = this.querySelector("div");
            if (img) img.style.backgroundImage = `url(/assets/img/${newState[player].base.img.hs})`;
        }
        if (newState[player].base === undefined) {
            const img = this.querySelector("div");
            if (img) img.style.backgroundImage = `url(/assets/img/han-solo.png)`;
        }
    }
    render() {
        const player = this.getAttribute("player");
        const wHeight = window.innerHeight / 2;
        const aspectRatio = 418 / 300;
        const wWidth = window.innerWidth > 500 ? 500 : window.innerWidth; // width of the screen
        const imgHeight = wWidth / aspectRatio; // height of the image based on the width
        const availableHeight = wHeight - 114;
        let marginToAdd = 0;
        if (imgHeight > availableHeight) marginToAdd = imgHeight - availableHeight;
        this.innerHTML = `
      <div
        class="bg-base-300 max-h-[50vh] min-h-[50vh] bg-no-repeat bg-bottom absolute left-0 z-0 bg-contain w-full 
${player === (0, $251c1d00443185ab$export$969a517631b92a15).top ? "" : ""}"
        style="background-image: url(/assets/img/han-solo.png); bottom: ${marginToAdd !== 0 ? `-${marginToAdd}px` : "0"};"
      >
        <select-base player="${player}"></select-base>
        <counter-value player="${player}">
      </div>
    `;
    }
    connectedCallback() {
        this.render();
    }
    dispatchEvent(event) {
        return false;
    }
}






function $5bd750e5b673cf26$var$millisToMinutesAndSeconds(millis) {
    const minutes = Math.floor(millis / 60000);
    const seconds = (millis % 60000 / 1000).toFixed(0);
    return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
}
function $5bd750e5b673cf26$export$4f483190244ba871(state) {
    if (state.currentGame === undefined) return "";
    const startTime = new Date(state.currentGame.startTime);
    const baseArr = state.currentGame.log.map((log)=>{
        const timestamp = new Date(log.timestamp);
        if (log.player === "none") return `<li class="flex flex-row log-item">
                <span class="text-xs italic">${$5bd750e5b673cf26$var$millisToMinutesAndSeconds(log.timeInGame)}</span>
                <span class="text-sm">${log.message}</span>
          </li>`;
        const player = state[log.player];
        return `<li class="flex log-item justify-between ${log.player === "top" ? "flex-row-reverse" : "flex-row "} ${log.player}">
          <img src="/assets/img/p_${player.leader.id}.png" width="32" height="32" class="" alt="${log.player + "/" + player.base.name}"/>
          <div>
            <span class="text-xs italic">${$5bd750e5b673cf26$var$millisToMinutesAndSeconds(log.timeInGame)}</span>
            <span class="text-sm">${log.message}</span>
          </div>
    </li>`;
    });
    return baseArr.join("");
}
function $5bd750e5b673cf26$export$e8c141cf2dfeba3(state) {
    if (state.currentGame === undefined) return "";
    const top = state.currentGame.topBase;
    const bottom = state.currentGame.bottomBase;
    let topDmg = 0;
    let bottomDmg = 0;
    let topHeal = 0;
    let bottomHeal = 0;
    state.currentGame.log.map((log)=>{
        if (log.player === "none") return;
        if (log.player === "top") {
            if (log.type === "Damage") topDmg += log.amount || 0;
            else if (log.type === "Heal") topHeal += log.amount || 0;
        } else {
            if (log.type === "Damage") bottomDmg += log.amount || 0;
            else if (log.type === "Heal") bottomHeal += log.amount || 0;
        }
    });
    const res = `<div>
          <h3 class="font-bold text-2xl">top/${top.base.name}</h3>
          <p><span class="font-bold">Damage done:</span> ${topDmg}</p>
          <p><span class="font-bold">Healing done:</span> ${topHeal}</p>
      </div>
      <div class="mt-2">
          <h3 class="font-bold text-2xl">bottom/${bottom.base.name}</h3>
          <p><span class="font-bold">Damage done:</span> ${bottomDmg}</p>
          <p><span class="font-bold">Healing done:</span> ${bottomHeal}</p>
      </div>`;
    return res;
}


class $e8b39df8edd32907$export$585478fdd8b59866 extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    constructor(){
        super();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        this.render();
    }
    registerEvents() {
        const rematch = this.querySelector("#rematch-btn");
        if (rematch) rematch.addEventListener("click", (e)=>{
            e.preventDefault();
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $4c2c1f9d3291d290$export$294ff5f8632c1e8f).rematch);
            this.render();
        });
        const reset = this.querySelector("#reset-base-btn");
        if (reset) reset.addEventListener("click", (e)=>{
            e.preventDefault();
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $b786174071d94ba7$export$9ec629e2b5a69446).resetAll);
            this.render();
        });
    }
    render() {
        if (this.state.currentGame !== undefined && this.state.currentGame.ended) {
            const damageState = (0, $5bd750e5b673cf26$export$e8c141cf2dfeba3)(this.state);
            this.innerHTML = `
      <dialog class="modal" id="end-game-modal" ${this.state.currentGame.ended === true ? "open" : ""}>
        <div class="modal-box">
        <div>
          <h3 class="font-bold text-2xl mb-2">Stats</h3>
          ${damageState}
        </div>
          <div
            class="match-ended-container p-2 flex flex-row justify-between items-center w-full "
            id="match-ended"
          >

          </div>
          <div class="modal-action p-2 flex flex-row justify-between items-center w-full ">
            <button
              type="button"
              class="btn btn-xl btn-success flex flex-col text-neutral"
              id="rematch-btn"
            >
              <span>Rematch</span>
            </button>

            <button
              type="button"
              class="btn btn-xl flex flex-col btn-error text-neutral"
              id="reset-base-btn"
            >
              <span>Reset bases</span>
            </button>
          </div>
        </div>
      </dialog>`;
            this.registerEvents();
            return;
        }
        this.innerHTML = ``;
    }
    connectedCallback() {
        this.render();
    }
    dispatchEvent(event) {
        return false;
    }
}






class $63d9b32c215dee55$export$5651728a01b02595 extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    static observedAttributes = [
        "player"
    ];
    constructor(){
        super();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        const gameStarted = oldState.currentGame === undefined && newState.currentGame !== undefined;
        const gameReStarted = oldState.currentGame?.ended === true && newState.currentGame?.ended === false;
        const gameEnded = oldState.currentGame?.ended === false && newState.currentGame?.ended === true;
        if (gameStarted || gameReStarted || gameEnded) this.render();
    }
    registerEvents() {
        const player = this.getAttribute("player");
        const reset = this.querySelector("#reset");
        reset.addEventListener("click", (e)=>{
            e.preventDefault();
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $b786174071d94ba7$export$9ec629e2b5a69446).resetBase, player);
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $32a6954a8dd0c1f7$export$6090639ede23396f).toggleSelectBase, {
                show: true,
                player: player
            });
        });
        const settings = this.querySelector("#settings");
        if (settings !== null) settings.addEventListener("click", (e)=>{
            e.preventDefault();
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $32a6954a8dd0c1f7$export$6090639ede23396f).toggleSettings, {
                show: true,
                player: player
            });
        });
        const log = this.querySelector("#log");
        log.addEventListener("click", (e)=>{
            e.preventDefault();
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $32a6954a8dd0c1f7$export$6090639ede23396f).toggleLog, {
                show: true,
                player: player
            });
        });
        const winner = this.querySelector("#winner");
        if (winner) winner.addEventListener("click", (e)=>{
            e.preventDefault();
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $32a6954a8dd0c1f7$export$6090639ede23396f).togglePickWinnerModal, {
                show: true,
                player: player
            });
        });
    }
    render() {
        const gameStarted = this.state.currentGame !== undefined;
        const gameEnded = this.state.currentGame?.ended;
        this.innerHTML = `
      <div class="absolute bottom-0 left-0 flex flex-row justify-between items-center p-1 z-[100] w-[calc(100%-2rem)]">
        <button title="Reset base" id="reset" class="border-0 cursor-pointer rounded-full bg-black p-2 ${gameStarted ? "hidden" : ""}">
          <img src="/assets/icons/reset.svg" alt="Reset arrow" width="24" height="24">
        </button>

        <button title="Set winner" id="winner" class="border-0 cursor-pointer rounded-full bg-black p-2 ${gameStarted ? "" : "hidden"} ${gameEnded ? "hidden" : ""}">
          <img src="/assets/icons/medal.svg" alt="Medal" width="24" height="24">
        </button>

        <button title="Open log" id="log" class="border-0 cursor-pointer rounded-full bg-black p-2 ${gameStarted ? "" : "hidden"}">
          <img src="/assets/icons/book.svg" alt="Log" width="24" height="24">
        </button>

      </div>`;
        this.registerEvents();
    }
    connectedCallback() {
        this.render();
    }
}



/**
 * @typedef {Object} Base
 * @property {string} name
 * @property {string} programmaticName
 * @property {string} subName
 * @property {string | undefined} epicAction
 * @property {string | undefined} passiveEffect
 * @property {string | undefined} repeatableEffect
 * @property {number | undefined} repeatableMax
 * @property {number | undefined} timesRepeated
 * @property {Object} img
 * @property {string} img.hs
 * @property {number} number
 * @property {number} hsNumber
 * @property {number} hp
 * @property {Object} set
 * @property {string} set.name
 * @property {string} set.short
 * @property {number} set.number
 * @property {Object} rarity
 * @property {string} rarity.name
 * @property {string} rarity.short
 * @property {string} artist
 * @property {Array<string>} aspect
 * @property {string} color
 *
 */ /**
 * @type {Object.<string, Base>}
 */ const $51b253b7ea05e272$export$196f613671eb7dd9 = {
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * BLUE BASES
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ securityComplex: {
        name: "Security Complex",
        programmaticName: "securityComplex",
        epicAction: "Give a Shield token to a non-leader unit.",
        img: {
            hs: "SWH_01_285_Security_Complex_Base_HYP.webp"
        },
        hp: 25,
        aspect: [
            "vigilance"
        ],
        color: "#2298D2"
    },
    colossus: {
        name: "Colossus",
        programmaticName: "colossus",
        passiveEffect: "Draw one less card in your starting hand.",
        img: {
            hs: "04020283_EN_Colossus_Base_228e3b72af.webp"
        },
        hp: 35,
        aspect: [
            "vigilance"
        ],
        color: "#2298D2"
    },
    pauCity: {
        name: "Pau City",
        programmaticName: "pauCity",
        passiveEffect: "Each leader unit you control gets +0/+1.",
        img: {
            hs: "0302294_EN_Pau_City_Base_35e40c7c65.webp"
        },
        hp: 26,
        aspect: [
            "vigilance"
        ],
        color: "#2298D2"
    },
    capitalCity: {
        name: "Vigilance 30",
        programmaticName: "capitalCity",
        img: {
            hs: "SWH_01_286_Capital_City_Base_HYP.webp"
        },
        hp: 30,
        aspect: [
            "vigilance"
        ],
        color: "#2298D2"
    },
    lofVigilance28: {
        name: "LoF Vigilance force base",
        programmaticName: "lofBlue28",
        passiveEffect: "When a friendly Force unit attacks: The Force is with you (create your Force token).",
        img: {
            hs: "05020285_EN_Shadowed_Undercity_Base_4415dad2ce.webp"
        },
        hp: 28,
        aspect: [
            "vigilance"
        ],
        color: "#2298D2"
    },
    vergenceTemple: {
        name: "Vergence Temple",
        programmaticName: "vengenceTemple",
        passiveEffect: "When the regroup phase starts: If you control a unit with 4 or more remaining HP, the Force is with you (create your Force token).",
        img: {
            hs: "05020283_EN_Vergence_Temple_Base_d2ca6afcf2.webp"
        },
        hp: 25,
        aspect: [
            "vigilance"
        ],
        color: "#2298D2"
    },
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * GREEN BASES
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ energyConversionLab: {
        name: "Energy Conversion Lab",
        programmaticName: "energyConversionLab",
        epicAction: "Play a unit that costs 6 resources or less from your hand. Give it AMBUSH for this phase.",
        img: {
            hs: "SWH_01_288_Energy_Conversion_Lab_Base_HYP.webp"
        },
        hp: 25,
        aspect: [
            "command"
        ],
        color: "#00A44D"
    },
    dataVault: {
        name: "Data vault",
        programmaticName: "dataVault",
        passiveEffect: "Your minimum deck size is increased by 10 cards.",
        img: {
            hs: "04020286_EN_Data_Vault_Base_7305a3e39d.webp"
        },
        hp: 33,
        aspect: [
            "command"
        ],
        color: "#00A44D"
    },
    droidManufactory: {
        name: "Droid Manufactory",
        programmaticName: "droidManufactory",
        passiveEffect: "When you deploy a leader: Create 2 Battle Droid tokens.",
        img: {
            hs: "0302297_EN_Droid_Manufactory_Base_cd1f4e0cc0.webp"
        },
        hp: 24,
        aspect: [
            "command"
        ],
        color: "#00A44D"
    },
    commandCenter: {
        name: "Command 30",
        programmaticName: "commandCenter",
        img: {
            hs: "SWH_01_289_command_Center_Base_HYP.webp"
        },
        hp: 30,
        aspect: [
            "command"
        ],
        color: "#00A44D"
    },
    lofCommand28: {
        name: "LoF command 28",
        programmaticName: "lofCommand28",
        passiveEffect: "When a friendly Force unit attacks: The Force is with you (create your Force token).",
        img: {
            hs: "05020287_EN_Jedi_Temple_Base_9423e40d8c.webp"
        },
        hp: 28,
        aspect: [
            "command"
        ],
        color: "#00A44D"
    },
    mysticMonastary: {
        name: "Mystic Monastary",
        programmaticName: "mysticMonastary",
        repeatableEffect: "The Force is with you . Use this ability no more than 3 times each game.",
        repeatableMax: 3,
        timesRepeated: 0,
        img: {
            hs: "05020286_EN_Mystic_Monastery_Base_3ef3dc3db8.webp"
        },
        hp: 25,
        aspect: [
            "command"
        ],
        color: "#00A44D"
    },
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * RED BASES
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ tarkintown: {
        name: "Tarkintown",
        programmaticName: "tarkintown",
        epicAction: "Deal 3 damage to a damaged non-leader unit.",
        img: {
            hs: "SWH_01_291_Tarkintown_Base_HYP.webp"
        },
        hp: 25,
        aspect: [
            "aggression"
        ],
        color: "#C31924"
    },
    thermalOscillator: {
        name: "Thermal Oscillator",
        programmaticName: "thermalOscillator",
        passiveEffect: "Your minimum deck size is decreased by 5 cards.",
        img: {
            hs: "04020287_EN_Thermal_Oscillator_Base_21d2984f02.webp"
        },
        hp: 27,
        aspect: [
            "aggression"
        ],
        color: "#C31924"
    },
    shadowCollectiveCamp: {
        name: "Shadow Collective Camp",
        programmaticName: "shadowCollectiveCamp",
        passiveEffect: "When you deploy a leader: Draw a card.",
        img: {
            hs: "0302300_EN_Shadow_Collective_Camp_Base_7221156d80.webp"
        },
        hp: 25,
        aspect: [
            "aggression"
        ],
        color: "#C31924"
    },
    catacombsOfCadera: {
        name: "Aggression 30",
        programmaticName: "catacombsOfCadera",
        img: {
            hs: "SWH_01_292_Catacombs_Of_Cadera_Base_HYP.webp"
        },
        hp: 30,
        aspect: [
            "aggression"
        ],
        color: "#C31924"
    },
    lofAggression28: {
        name: "LoF aggression 28",
        programmaticName: "lofAggression28",
        passiveEffect: "When a friendly Force unit attacks: The Force is with you (create your Force token).",
        img: {
            hs: "05020290_EN_Fortress_Vader_Base_a94f9de0c9.webp"
        },
        hp: 28,
        aspect: [
            "aggression"
        ],
        color: "#C31924"
    },
    templeOfDestruction: {
        name: "Temple of Destruction",
        programmaticName: "templeOfDestruction",
        passiveEffect: "When a friendly unit deals 3 or more combat damage to an enemy base: The Force is with you .",
        img: {
            hs: "05020289_EN_Temple_of_Destruction_Base_fdc4bdb563.webp"
        },
        hp: 25,
        aspect: [
            "aggression"
        ],
        color: "#C31924"
    },
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * YELLOW BASES
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ jedhaCity: {
        name: "Jedha City",
        programmaticName: "jedhaCity",
        epicAction: "Give a non-leader unit -4/-0 for this phase.",
        img: {
            hs: "SWH_01_294_Jedha_City_Base_HYP.webp"
        },
        hp: 25,
        aspect: [
            "cunning"
        ],
        color: "#F0BA32"
    },
    nabatVillage: {
        name: "Nabat Village",
        programmaticName: "nabatVillage",
        passiveEffect: "Draw 3 more cards in your starting hand. You can't take a mulligan.\n\nWhen the first action phase starts: Put 3 cards from your hand on the bottom of your deck in any order.",
        img: {
            hs: "04020290_EN_Nabat_Village_Base_a9ce26189d.webp"
        },
        hp: 25,
        aspect: [
            "cunning"
        ],
        color: "#F0BA32"
    },
    administratorsTower: {
        name: "Cunning 30",
        programmaticName: "administratorsTower",
        img: {
            hs: "SWH_01_295_Administrators_Tower_Base_HYP.webp"
        },
        hp: 30,
        aspect: [
            "cunning"
        ],
        color: "#F0BA32"
    },
    lofCunning28: {
        name: "LoF cunning 28",
        programmaticName: "lofCunning28",
        img: {
            hs: "05020293_EN_Crystal_Caves_Base_1df381e0d5.webp"
        },
        hp: 28,
        aspect: [
            "cunning"
        ],
        color: "#F0BA32"
    },
    tombOfEilram: {
        name: "Tomb Of Eilram",
        programmaticName: "tombOfEilram",
        repeatableEffect: "Action [exhaust a friendly unit]: The Force is with you .",
        repeatableMax: 99,
        img: {
            hs: "05020292_EN_Tomb_of_Eilram_Base_ea9f20002d.webp"
        },
        hp: 25,
        aspect: [
            "cunning"
        ],
        color: "#F0BA32"
    },
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * NEUTRAL BASES
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */ lakeCountry: {
        name: "Lake Country",
        programmaticName: "lakeCountry",
        img: {
            hs: "04020293_EN_Lake_Country_Base_06121aca30.webp"
        },
        hp: 34,
        aspect: [
            "neutral"
        ],
        color: "#ccc"
    }
};
const $51b253b7ea05e272$export$c30891da9cb15db = Object.keys($51b253b7ea05e272$export$196f613671eb7dd9);
const $51b253b7ea05e272$export$b06a1eef649e2a6a = Object.values($51b253b7ea05e272$export$196f613671eb7dd9);
const $51b253b7ea05e272$export$1d1399851f1b31fd = $51b253b7ea05e272$export$b06a1eef649e2a6a.map((base)=>{
    return `<li class="flex flex-row">
    <span style="background-color: ${base.color}" class="w-[20px] min-h-5 inline-block mr-2">&nbsp;</span>
    <button class="base flex flex-row justify-between w-full p-2" data-base="${base.programmaticName}"><span>${base.name}</span><span>${base.hp}hp</span></button>
    </li>`;
});






class $80becc05f041971d$export$77c61c51bc96457e extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    constructor(){
        super();
    }
    baseElementList() {
        const baseArr = (0, $51b253b7ea05e272$export$b06a1eef649e2a6a).map((base)=>{
            return `<li class="flex flex-row min-h-1">
        <span style="background-color: ${(0, $251c1d00443185ab$export$50918c26e7741530)[base.aspect]}" class="inline-block mr-2 w-[20px]">&nbsp;</span>
        <button 
          class="pointer border-b flex flex-row justify-between w-full px-2 py-4 " 
          data-base="${base.programmaticName}">
            <span>${base.name}</span><span>${base.hp}hp</span>
          </button>
        </li>`;
        });
        return baseArr.join("");
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        // Should open modal
        const modal = this.querySelector("#select-modal");
        const player = this.state.ui.showBaseModal.player;
        if (newState.ui.showBaseModal.show && !oldState.ui.showBaseModal.show) {
            if (player === (0, $251c1d00443185ab$export$969a517631b92a15).top) modal.classList.add("rotate-180");
            else modal.classList.remove("rotate-180");
            modal.showModal();
            return;
        }
        // Should close modal
        if (!newState.ui.showBaseModal.show && oldState.ui.showBaseModal.show) modal.close();
    }
    registerElementEvents() {
        const modal = this.querySelector("#select-modal");
        const baseItems = this.querySelectorAll("#base-list button");
        const closeBtn = this.querySelector("#close");
        closeBtn.addEventListener("click", ()=>{
            const player = this.state.ui.showBaseModal.player;
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $32a6954a8dd0c1f7$export$6090639ede23396f).toggleSelectBase, {
                show: false,
                player: player
            });
        });
        baseItems.forEach((button)=>{
            button.addEventListener("click", (event)=>{
                const player = this.state.ui.showBaseModal.player;
                const selectedBase = (0, $51b253b7ea05e272$export$b06a1eef649e2a6a).find((b)=>b.programmaticName === button.dataset.base);
                console.log("\uD83E\uDD95: ", player, selectedBase);
                (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $b786174071d94ba7$export$9ec629e2b5a69446).setBase, {
                    base: selectedBase,
                    player: player
                });
                (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $32a6954a8dd0c1f7$export$6090639ede23396f).toggleSelectBase, {
                    show: false,
                    player: player
                });
                modal.close();
            });
        });
    }
    render() {
        this.innerHTML = `
        <dialog class="modal z-50" id="select-modal">
          <div class="modal-box">
            <h3 class="font-bold text-2xl mb-2">Select your base!</h3>
            <ul id="base-list">
              ${this.baseElementList()}
            </ul>
            <div class="modal-action">
                <button id="close" class="btn w-full mt-2">Close</button>
            </div>
          </div>
        </dialog>
        `;
    }
    connectedCallback() {
        this.render();
        this.registerElementEvents();
    }
    dispatchEvent(event) {
        return false;
    }
}







class $3eb993ebf650684c$export$626d11413ed62030 extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    constructor(){
        super();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        if (newState.ui.showPickWinnerModal.show !== oldState.ui.showPickWinnerModal.show) this.render();
    }
    registerElementEvents() {
        const player = this.state.ui.showPickWinnerModal.player;
        const selectedReason = this.querySelector("input[name='reason']:checked");
        const closeBtn = this.querySelector("#close");
        closeBtn.addEventListener("click", ()=>{
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $4c2c1f9d3291d290$export$294ff5f8632c1e8f).setWinner, {
                player: player,
                reason: selectedReason
            });
        });
        const cancelBtn = this.querySelector("#cancel");
        cancelBtn.addEventListener("click", ()=>{
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $32a6954a8dd0c1f7$export$6090639ede23396f).togglePickWinnerModal, {
                show: false
            });
        });
    }
    render() {
        const player = this.state.ui.showPickWinnerModal.player;
        if (this.state.ui.showPickWinnerModal.show === false) {
            this.innerHTML = "";
            return;
        }
        if (player === "none") {
            this.innerHTML = "";
            return;
        }
        const winnerBase = this.state[player].base;
        this.innerHTML = `
        <dialog class="modal winner-modal ${player === (0, $251c1d00443185ab$export$969a517631b92a15).top ? "rotate-180" : ""}" id="select-modal" ${this.state.ui.showPickWinnerModal.show === true ? "open" : ""}>
          <div class="modal-box">
            <h2 class="winner-modal-h2">Set winner</h2>
              <h3 class="winner-modal-h3">${winnerBase.name} wins</h3>
              <ul>
                <li>
                <label for="forfeit" class="reason">
                    <input type="radio" name="reason" value="forfeit" id="forfeit" class="radio" checked>
                    <span>Forfeit</span>
                  </label>
                </li>
                <li>
                <label for="time" class="reason">
                    <input type="radio" name="reason" value="time" id="time" class="radio">
                    <span>Out of time</span>
                  </label>
                </li>
              </ul>
              <h3 class="winner-modal-h3">No winner</h3>
              <ul>
                <li>
                <label for="draw" class="reason">
                    <input type="radio" name="reason" value="draw" id="draw" class="radio">
                    <span>Draw</span>
                  </label>
                </li>
              </ul>

            <div class="modal-action">
                <button id="close" class="btn btn-primary mt-2">Submit</button>
                <button id="cancel" class="btn mt-2">Cancel</button>
            </div>
          </div>
        </dialog>
      </div>`;
        this.registerElementEvents();
    }
    connectedCallback() {
        this.render();
    }
}





class $4f46944e3481f56f$export$1687a8750135f014 extends HTMLElement {
    static observedAttributes = [
        "player"
    ];
    amountHealed = 1;
    constructor(){
        super();
        (0, $49a3b7170c6ecdc1$export$e9feafb5b7d09568)((0, $4c2c1f9d3291d290$export$294ff5f8632c1e8f).heal, (e)=>{
            console.log("\uD83E\uDDD9\u200D\u2642\uFE0F: State updated BaseHeal", e);
            if (e.player !== this.getAttribute("player")) return;
            this.amountHealed = e.amount;
            this.render();
            this.triggerAnimation();
        });
    }
    triggerAnimation() {
        const overlay = this.querySelector("#heal-overlay");
        overlay.classList.remove("hidden");
        setTimeout(()=>{
            overlay.classList.add("hidden");
        }, 1000);
        const images = this.querySelectorAll("img");
        images.forEach((image)=>{
            image.classList.add("fade-out-up");
            setTimeout(()=>{
                image.classList.remove("fade-out-up");
            }, 900);
        });
        const heading = this.querySelector("h2");
        heading.classList.add("bounce-out");
        setTimeout(()=>{
            heading.classList.remove("bounce-out");
        }, 900);
    }
    render() {
        new Audio("/assets/sound/heal.mp3").play();
        this.innerHTML = `
      <div
        class="hidden bottom-0 justify-center items-center flex-col w-full h-full flex z-40 absolute max-h-[300px]"
        id="heal-overlay"
      >
        <h2 class="text-shadow hidden bottom-[30%] font-extrabold text-center absolute font-normal text-2xl z-50">
          Healing ${this.amountHealed} damage
        </h2>
        <img
          class="drop-shadow-white hidden absolute icon-1"
          alt="Healing cross"
          height="24"
          loading="lazy"
          src="/assets/icons/heal-green.svg"
          width="24"
        />
        <img
          class="drop-shadow-white hidden absolute icon-2"
          alt="Healing cross"
          height="24"
          loading="lazy"
          src="/assets/icons/heal-green.svg"
          width="24"
        />
        <img
          class="drop-shadow-white hidden absolute icon-3"
          alt="Healing cross"
          height="24"
          loading="lazy"
          src="/assets/icons/heal-green.svg"
          width="24"
        />
        <img
          class="drop-shadow-white hidden absolute icon-4"
          alt="Healing cross"
          height="24"
          loading="lazy"
          src="/assets/icons/heal-green.svg"
          width="24"
        />
        <img
          class="drop-shadow-white hidden absolute icon-5"
          alt="Healing cross"
          height="24"
          loading="lazy"
          src="/assets/icons/heal-green.svg"
          width="24"
        />
        <img
          class="drop-shadow-white hidden absolute icon-6"
          alt="Healing cross"
          height="24"
          loading="lazy"
          src="/assets/icons/heal-green.svg"
          width="24"
        />
        <img
          class="drop-shadow-white hidden absolute icon-7"
          alt="Healing cross"
          height="24"
          loading="lazy"
          src="/assets/icons/heal-green.svg"
          width="24"
        />
      </div>
      `;
    }
    connectedCallback() {
        this.render();
    }
}





class $34240cdfec9b798d$export$18bf9156e6515ba8 extends HTMLElement {
    static observedAttributes = [
        "player"
    ];
    damageTaken = 1;
    constructor(){
        super();
        (0, $49a3b7170c6ecdc1$export$e9feafb5b7d09568)((0, $4c2c1f9d3291d290$export$294ff5f8632c1e8f).damage, (e)=>{
            if (e.player !== this.getAttribute("player")) return;
            this.damageTaken = e.amount;
            this.render();
            this.triggerAnimation();
        });
    }
    triggerAnimation() {
        const overlay = this.querySelector("#damage-overlay");
        overlay.classList.remove("hidden");
        setTimeout(()=>{
            overlay.classList.add("hidden");
        }, 1000);
        const images = this.querySelectorAll("img");
        images.forEach((image)=>{
            image.classList.add("bounce-in");
            setTimeout(()=>{
                image.classList.remove("bounce-in");
            }, 900);
        });
        const heading = this.querySelector("h2");
        heading.classList.add("bounce-out");
        setTimeout(()=>{
            heading.classList.remove("bounce-out");
        }, 900);
    }
    render() {
        new Audio("/assets/sound/damage.mp3").play();
        this.innerHTML = `
      <div
        class="hidden bottom-0 justify-center items-center flex-col w-full h-full flex z-40 absolute max-h-[300px]"
        id="damage-overlay"
      >
        <h2 class="text-shadow hidden bottom-[30%] font-extrabold text-center absolute font-normal text-2xl z-50">
          ${this.damageTaken} damage taken
        </h2>
        <img
          class="drop-shadow-white hidden absolute icon-1"
          alt="Damage icon"
          height="48"
          loading="lazy"
          src="/assets/icons/damage-red.svg"
          width="48"
        />
        <img
          class="drop-shadow-white hidden absolute icon-2"
          alt="Damage icon"
          height="48"
          loading="lazy"
          src="/assets/icons/damage-red.svg"
          width="48"
        />
        <img
          class="drop-shadow-white hidden absolute icon-3"
          alt="Damage icon"
          height="48"
          loading="lazy"
          src="/assets/icons/damage-red.svg"
          width="48"
        />
        <img
          class="drop-shadow-white hidden absolute icon-4"
          alt="Damage icon"
          height="48"
          loading="lazy"
          src="/assets/icons/damage-red.svg"
          width="48"
        />
        <img
          class="drop-shadow-white hidden absolute icon-5"
          alt="Damage icon"
          height="48"
          loading="lazy"
          src="/assets/icons/damage-red.svg"
          width="48"
        />
        <img
          class="drop-shadow-white hidden absolute icon-6"
          alt="Damage icon"
          height="48"
          loading="lazy"
          src="/assets/icons/damage-red.svg"
          width="48"
        />
        <img
          class="drop-shadow-white hidden absolute icon-7"
          alt="Damage icon"
          height="48"
          loading="lazy"
          src="/assets/icons/damage-red.svg"
          width="48"
        />
      </div>
      `;
    }
    connectedCallback() {
        this.render();
    }
}






class $cee30dd3c9eb63a8$export$15afaf45c56450ea extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    static observedAttributes = [
        "player"
    ];
    timerSeconds = 0;
    timerRunning = false;
    interval;
    constructor(){
        super();
        this.render();
        this.startTimer();
        (0, $49a3b7170c6ecdc1$export$e9feafb5b7d09568)((0, $b786174071d94ba7$export$1144cef7e5483214).startTimer, ()=>{
            this.startTimer();
        });
        (0, $49a3b7170c6ecdc1$export$e9feafb5b7d09568)((0, $4c2c1f9d3291d290$export$294ff5f8632c1e8f).end, ()=>{
            this.stopTimer();
        });
        (0, $49a3b7170c6ecdc1$export$e9feafb5b7d09568)((0, $b786174071d94ba7$export$1144cef7e5483214).stopTimer, ()=>{
            this.stopTimer();
        });
        (0, $49a3b7170c6ecdc1$export$e9feafb5b7d09568)((0, $b786174071d94ba7$export$1144cef7e5483214).resetTimer, ()=>{
            this.resetTimer();
        });
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        if (oldState.currentGame === undefined && newState.currentGame !== undefined || oldState.currentGame?.ended === true && newState.currentGame?.ended === true) this.render();
    }
    resetTimer() {
        this.timerSeconds = 0;
        this.render();
    }
    startTimer() {
        if (this.timerRunning) return;
        this.timerRunning = true;
        this.render();
        this.interval = setInterval(()=>{
            this.timerSeconds++;
            this.renderTimer();
        }, 1000);
    }
    stopTimer() {
        clearInterval(this.interval);
        this.timerRunning = false;
        this.render();
    }
    addLeadingZero(value) {
        return value < 10 ? `0${value}` : value;
    }
    getTime() {
        const minutes = Math.floor(this.timerSeconds / 60);
        const seconds = this.timerSeconds % 60;
        if (minutes > 60) return `${this.addLeadingZero(Math.floor(minutes / 60))}:${this.addLeadingZero(minutes % 60)}:${this.addLeadingZero(seconds)}`;
        return `${this.addLeadingZero(minutes)}:${this.addLeadingZero(seconds)}`;
    }
    renderTimer() {
        const timeEl = this.querySelector("#time");
        if (timeEl) timeEl.innerText = this.getTime();
    }
    registerEvents() {
        const start = this.querySelector("#start");
        const stop = this.querySelector("#stop");
        const reset = this.querySelector("#reset");
        start && start.addEventListener("click", ()=>{
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $b786174071d94ba7$export$1144cef7e5483214).startTimer);
        });
        stop && stop.addEventListener("click", ()=>{
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $b786174071d94ba7$export$1144cef7e5483214).stopTimer);
        });
        reset && reset.addEventListener("click", ()=>{
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $b786174071d94ba7$export$1144cef7e5483214).resetTimer);
        });
    }
    render() {
        if (this.state.currentGame === undefined || this.state.currentGame?.ended) {
            clearInterval(this.interval);
            this.timerRunning = false;
            this.innerHTML = "";
            return;
        }
        if (this.timerRunning) this.innerHTML = `
        <div class="flex items-center justify-end mt-3">
          <button id="stop" class="border-0 cursor-pointer bg-transparent">
            <img src="/assets/icons/timer.svg" alt="Start timer" width="24" height="24" class="bg-black p-1 rounded-full" />
          </button>
          <span id="time">${this.getTime()}</span>
        </div>
      `;
        else this.innerHTML = `
        <div class="flex items-center justify-end mt-3">
          <button id="reset" class="border-0 cursor-pointer bg-transparent">
            <img src="/assets/icons/reset.svg" alt="Reset timer" width="24" height="24" class="bg-black p-1 rounded-full" />
          </button>
          <button id="start" class="border-0 cursor-pointer bg-transparent">
            <img src="/assets/icons/timer-off.svg" alt="Start timer" width="24" height="24" class="bg-black p-1 rounded-full" />
          </button>
          <span>${this.getTime()}</span>
        </div>
      `;
        this.registerEvents();
    }
    connectedCallback() {
        this.render();
    }
}






/**
 * @typedef {Object} LeaderCard
 * @property {string} card.front
 * @property {string} card.back
 */ /**
 * @typedef {Object} Leader
 * @property {string} id
 * @property {string} name
 * @property {string} subTitle
 * @property {Array<string>} aspect
 * @property {LeaderCard} card
 *
 */ /**
 * @type {Array<Leader>}
 */ const $3e6a3530b18ca7f6$export$23a35d50bb37c2f6 = [
    {
        id: "SOR001",
        name: "Director Krennic",
        subTitle: "Aspiring to Authority",
        aspect: [
            "vigilance",
            "villain"
        ],
        card: {
            front: "SWH_01_001_Director_Krennic_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SOR002",
        name: "Iden Versio",
        subTitle: "Inferno Squad Commander",
        aspect: [
            "vigilance",
            "villain"
        ],
        card: {
            front: "SWH_01_002_Iden_Versio_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SOR003",
        name: "Chewbacca",
        subTitle: "Walking Carpet",
        aspect: [
            "vigilance",
            "heroism"
        ],
        card: {
            front: "SWH_01_003_Chewbacca_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SOR004",
        name: "Chirrut \xcemwe",
        subTitle: "One with the Force",
        aspect: [
            "vigilance",
            "heroism"
        ],
        card: {
            front: "SWH_01_004_Chirrut_\xcemwe_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SOR005",
        name: "Luke Skywalker",
        subTitle: "Faithful friend",
        aspect: [
            "vigilance",
            "heroism"
        ],
        card: {
            front: "SWH_01_005_Luke_Skywalker_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SHD001",
        name: "Gar Saxon",
        subTitle: "Viceroy of Mandalore",
        aspect: [
            "vigilance",
            "villain"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SHD002",
        name: "Qi\u2019ra",
        subTitle: "I Alone Survived",
        aspect: [
            "vigilance",
            "villain"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SHD003",
        name: "Finn",
        subTitle: "This is a Rescue",
        aspect: [
            "vigilance",
            "heroism"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SHD004",
        name: "Rey",
        subTitle: "More Than a Scavenger",
        aspect: [
            "vigilance",
            "heroism"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SOR006",
        name: "Emperor Palpatine",
        subTitle: "Galactic Ruler",
        aspect: [
            "command",
            "villain"
        ],
        card: {
            front: "SWH_01_006_Emperor_Palpatine_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SOR007",
        name: "Grand Moff Tarkin",
        subTitle: "Oversector Governor",
        aspect: [
            "command",
            "villain"
        ],
        card: {
            front: "SWH_01_007_Grand_Moff_Tarkin_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SOR008",
        name: "Hera Syndulla",
        subTitle: "Spectre two",
        aspect: [
            "command",
            "heroism"
        ],
        card: {
            front: "SWH_01_008_Hera_Syndulla_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SOR009",
        name: "Leia Organa",
        subTitle: "Alliance general",
        aspect: [
            "command",
            "heroism"
        ],
        card: {
            front: "SWH_01_009_Leia_Organa_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SHD005",
        name: "Hondo Ohnaka",
        subTitle: "That\u2019s Good Business",
        aspect: [
            "command",
            "villain"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SHD006",
        name: "Jabba the Hutt",
        subTitle: "His High Exaltedness",
        aspect: [
            "command",
            "villain"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SHD007",
        name: "Moff Gideon",
        subTitle: "Formidable Commander",
        aspect: [
            "command",
            "villain"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SHD008",
        name: "Boba Fett",
        subTitle: "Daimyo",
        aspect: [
            "command",
            "heroism"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SHD009",
        name: "Hunter",
        subTitle: "Outcast Sergeant",
        aspect: [
            "command",
            "heroism"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SOR010",
        name: "Darth Vader",
        subTitle: "Dark Lord of the Sith",
        aspect: [
            "aggression",
            "villain"
        ],
        card: {
            front: "SWH_01_010_Darth_Vader_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SOR011",
        name: "Grand Inquisitor",
        subTitle: "Hunting the Jedi",
        aspect: [
            "aggression",
            "villain"
        ],
        card: {
            front: "SWH_01_011_Grand_Inquisitor_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SOR012",
        name: "IG-88",
        subTitle: "Ruthless Bounty Hunter",
        aspect: [
            "aggression",
            "villain"
        ],
        card: {
            front: "SWH_01_012_IG-88_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SOR013",
        name: "Cassian Andor",
        subTitle: "Dedicated to the rebellion",
        aspect: [
            "aggression",
            "heroism"
        ],
        card: {
            front: "SWH_01_013_Cassian_Andor_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SOR014",
        name: "Sabine Wren",
        subTitle: "Galvanized Revolutionary",
        aspect: [
            "aggression",
            "heroism"
        ],
        card: {
            front: "SWH_01_014_Sabine_Wren_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SHD010",
        name: "Bossk",
        subTitle: "Hunting His Prey",
        aspect: [
            "aggression",
            "villain"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SHD011",
        name: "Kylo Ren",
        subTitle: "Rash and Deadly",
        aspect: [
            "aggression",
            "villain"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SHD012",
        name: "Bo-Katan Kryze",
        subTitle: "Princess in Exile",
        aspect: [
            "aggression",
            "heroism"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SHD013",
        name: "Han Solo",
        subTitle: "Worth the Risk",
        aspect: [
            "aggression",
            "heroism"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SOR015",
        name: "Bobba Fett",
        subTitle: "Collecting the Bounty",
        aspect: [
            "cunning",
            "villain"
        ],
        card: {
            front: "SWH_01_015_Bobba_Fett_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SOR016",
        name: "Grand Admiral Thrawn",
        subTitle: "Patient and Insightful",
        aspect: [
            "cunning",
            "villain"
        ],
        card: {
            front: "SWH_01_016_Grand_Admiral_Thrawn_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SOR017",
        name: "Han Solo",
        subTitle: "Audacious Smuggler",
        aspect: [
            "cunning",
            "heroism"
        ],
        card: {
            front: "SWH_01_017_Han_Solo_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SOR018",
        name: "Jyn Erso",
        subTitle: "Resisting Opression",
        aspect: [
            "cunning",
            "heroism"
        ],
        card: {
            front: "SWH_01_018_Jyn_Erso_Front_HYP.webp",
            back: undefined
        }
    },
    {
        id: "SHD014",
        name: "Cad Bane",
        subTitle: "He Who Needs No Introduction",
        aspect: [
            "cunning",
            "villain"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SHD015",
        name: "Doctor Aphra",
        subTitle: "Rapacious Archaeologist",
        aspect: [
            "cunning",
            "villain"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SHD016",
        name: "Fennec Shand",
        subTitle: "Honoring the Deal",
        aspect: [
            "cunning",
            "heroism"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SHD017",
        name: "Lando Calrissian",
        subTitle: "With Impeccable Taste",
        aspect: [
            "cunning",
            "heroism"
        ],
        card: {
            front: "",
            back: undefined
        }
    },
    {
        id: "SHD018",
        name: "The Mandalorian",
        subTitle: "Sworn To The Creed",
        aspect: [
            "cunning",
            "heroism"
        ],
        card: {
            front: "",
            back: undefined
        }
    }
];



class $9e4b481250188a54$export$c11650baacf39e2f extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    constructor(){
        super();
    }
    getLeaderAspects(leader) {
        let aspects = "";
        leader.aspect.map((aspect)=>{
            aspects += `<span style="background-color: ${(0, $251c1d00443185ab$export$50918c26e7741530)[aspect]}" class="inline-block base-color">&nbsp;</span>`;
        });
        return aspects;
    }
    leaderElementList() {
        const baseArr = (0, $3e6a3530b18ca7f6$export$23a35d50bb37c2f6).map((leader)=>{
            return `<li class="flex flex-row leader-item">
      ${this.getLeaderAspects(leader)}
    <button class="leader flex flex-row justify-between w-full p-2 ml-2" data-leader="${leader.id}"><span>${leader.name}</span></button>
    </li>`;
        });
        return baseArr.join("");
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        if (newState.ui.showLeaderModal.show !== oldState.ui.showLeaderModal.show) this.render();
    }
    registerElementEvents() {
        const player = this.state.ui.showLeaderModal.player;
        const modal = this.querySelector("#select-leader-modal");
        const leaderItems = this.querySelectorAll(".leader");
        const closeBtn = this.querySelector("#close");
        closeBtn.addEventListener("click", ()=>{
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $32a6954a8dd0c1f7$export$6090639ede23396f).toggleSelectLeader, {
                show: false,
                player: player
            });
        });
        leaderItems.forEach((button)=>{
            button.addEventListener("click", (event)=>{
                const selectedLeader = (0, $3e6a3530b18ca7f6$export$23a35d50bb37c2f6).find((b)=>b.id === button.dataset.leader);
                (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $b786174071d94ba7$export$9ec629e2b5a69446).setLeader, {
                    leader: selectedLeader,
                    player: player
                });
                (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $32a6954a8dd0c1f7$export$6090639ede23396f).toggleSelectLeader, {
                    show: false,
                    player: player
                });
                modal.close();
            });
        });
    }
    render() {
        const player = this.state.ui.showLeaderModal.player;
        if (player === "none") {
            this.innerHTML = "";
            return;
        }
        this.innerHTML = `
        <dialog class="modal ${player === "top" ? "rotate-180" : ""}" id="select-leader-modal" ${this.state.ui.showLeaderModal.show === true ? "open" : ""}>
          <div class="modal-box">
            <h3 class="font-bold text-2xl mb-2">Select your leader</h3>
            <ul id="leader-list">
              ${this.leaderElementList()}
            </ul>
            <div class="modal-action">
                <button id="close" class="btn w-full mt-2">Close</button>
            </div>
          </div>
        </dialog>
      </div>
        `;
        this.registerElementEvents();
    }
    connectedCallback() {
        this.render();
    }
    dispatchEvent(event) {
        return false;
    }
}





class $aa9c6d01304a85fe$export$7ec8a35823165bea extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    static observedAttributes = [
        "player",
        "align"
    ];
    constructor(){
        super();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        const player = this.getAttribute("player");
        if (newState[player].leader !== oldState[player].leader) this.render();
    }
    registerElementEvents() {
        const player = this.getAttribute("player");
        const openLeaderModalBtn = this.querySelector("#open-leader-modal");
        if (openLeaderModalBtn === null) return;
        openLeaderModalBtn.addEventListener("click", ()=>{
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $32a6954a8dd0c1f7$export$6090639ede23396f).toggleSelectLeader, {
                show: true,
                player: player
            });
        });
    }
    render() {
        const player = this.getAttribute("player");
        const align = this.getAttribute("align");
        const leader = this.state[player].leader;
        let profileImg = "/assets/icons/yoda.svg";
        let leaderName = "Select leader";
        if (leader !== undefined) {
            profileImg = `/assets/img/p_${leader.id}.png`;
            leaderName = player;
        }
        this.innerHTML = `
      <button
        class="leader-profile ${align === "bottom" ? "bottom" : ""}"
        id="open-leader-modal"
      >
        <img src="${profileImg}" width="32" height="32" alt="${leaderName}" />
        <p>${leaderName}</p>
      </button>
    `;
        this.registerElementEvents();
    }
    connectedCallback() {
        this.render();
    }
}






class $13acaba22642f788$export$b7fea4424a75e2e7 extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    constructor(){
        super();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        if (newState.ui.showLog.show !== oldState.ui.showLog.show) this.render();
    }
    registerElementEvents() {
        const player = this.state.ui.showLog.player;
        const closeBtn = this.querySelector("#close");
        closeBtn.addEventListener("click", ()=>{
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $32a6954a8dd0c1f7$export$6090639ede23396f).toggleLog, {
                show: false,
                player: player
            });
        });
    }
    render() {
        const player = this.state.ui.showLog.player;
        this.innerHTML = `<link href="/static/styles.css" rel="stylesheet" />
        <dialog class="z-50 ${player === "top" ? "rotate-180" : ""}" id="select-modal" ${this.state.ui.showLog.show === true ? "open" : ""}>
          <div class="modal-box">
            <h3 class="font-bold text-2xl mb-2">Game log</h3>
            <ul id="base-list" class="[&_.base-color]:w-5 [&_.log-item]:min-h-[5px] [&_.log-item]:my-1 [&_.base]:border-b [&_.base]:border-[#111] [&_.base:first-child]:border-t [&_.base:first-child]:border-[#111]">
              ${(0, $5bd750e5b673cf26$export$4f483190244ba871)(this.state)}
            </ul>
            <div class="modal-action">
                <button id="close" class="btn w-full mt-2">Close</button>
            </div>
          </div>
        </dialog>
      </div>
        `;
        this.registerElementEvents();
    }
    connectedCallback() {
        this.render();
    }
}





class $bec6e70bc6563a27$export$88c326727b6c1d28 extends (0, $d6c55283e5567e0f$export$c7bac36d9db821bc) {
    result = undefined;
    evens = 0;
    odds = 0;
    constructor(){
        super();
    }
    /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */ stateUpdated(newState, oldState) {
        if (newState.ui.showInitiative.show !== oldState.ui.showInitiative.show) this.render();
    }
    registerElementEvents() {
        const player = this.state.ui.showInitiative.player;
        const closeBtn = this.querySelector("#close");
        if (closeBtn !== null) closeBtn.addEventListener("click", ()=>{
            (0, $49a3b7170c6ecdc1$export$12f655127a1457b7)((0, $32a6954a8dd0c1f7$export$6090639ede23396f).toggleInitiativeModal, {
                show: false,
                player: player
            });
        });
        const rollBtn = this.querySelector("#roll");
        if (rollBtn !== null) rollBtn.addEventListener("click", ()=>{
            this.rollInitiative();
        });
    }
    rollInitiative() {
        this.evens = 0;
        this.odds = 0;
        for(let i = 0; i < 1000; i++){
            const roll = Math.floor(Math.random() * 6) + 1;
            if (roll % 2 === 0) this.evens++;
            else this.odds++;
        }
        this.result = this.evens > this.odds ? 0 : 1;
        this.render();
    }
    render() {
        const player = this.state.ui.showInitiative.player;
        const winnerName = this.result !== undefined ? this.result % 2 === 0 ? "Deathstar" : "Yoda" : "";
        const resultEl = this.result !== undefined ? `<div>
      <h1>${winnerName} Wins!</h1>
      <p>Winning roll: ${this.evens} vs ${this.odds}</p>
    </div>` : "";
        this.innerHTML = `
        <dialog class="z-50 modal ${player === "top" ? "rotate-180" : ""}" id="select-modal" ${this.state.ui.showInitiative.show === true ? "open" : ""}>
          <div class="modal-box">
            <h3 class="font-bold text-2xl mb-2">Roll for initiative?</h3>
            <div class="mb-4">
              <p class="mb-4">Pick Yoda (odd) or Deathstar (even)</p>
              <p class="flex justify-center flex-row items-center">
                <img src="/assets/icons/deathstar.svg" width="64" height="64" alt="Deathstar" class="${winnerName === "Yoda" ? "opacity-50" : ""}">
                <img src="/assets/icons/yoda.svg" width="64" height="64" alt="Yoda" class="${winnerName === "Deathstar" ? "opacity-50" : ""}">
              </p>
            </div>
            ${resultEl}
            <div class="modal-action">
                <button id="roll" class="btn mt-2">Roll initiative!</button>
                <button id="close" class="btn mt-2">Close</button>
            </div>
          </div>
        </dialog>
      </div>
        `;
        this.registerElementEvents();
    }
    connectedCallback() {
        this.render();
    }
}


function $440d289ff3253aed$export$b6af53c581e4325c() {
    customElements.define("start-match", (0, $1f2ef80fd5e2c367$export$432afc5e995117f8));
    customElements.define("base-counter", (0, $1c52bf34e3765fde$export$e30d303f4ee9312e));
    customElements.define("counter-value", (0, $788451c9c961b342$export$8efd160a88d6fdc7));
    customElements.define("base-win", (0, $a6dad443d03ae1af$export$1e1e5f57917ff9ab));
    customElements.define("base-lose", (0, $01d35cce215b0922$export$19239e31aef9944c));
    customElements.define("base-initiative", (0, $7886e5e512d2b761$export$870266edbe4a201b));
    customElements.define("base-epic", (0, $467fdd11151b9461$export$a6af1aae51e188bd));
    customElements.define("base-area", (0, $166120334c418ac7$export$6c78f30ecf8eb3f2));
    customElements.define("match-ended", (0, $e8b39df8edd32907$export$585478fdd8b59866));
    customElements.define("settings-bar", (0, $63d9b32c215dee55$export$5651728a01b02595));
    customElements.define("select-base", (0, $f1bfe6681c8b0c97$export$6b437c5bf6e35b26));
    customElements.define("select-base-modal", (0, $80becc05f041971d$export$77c61c51bc96457e));
    customElements.define("select-leader-modal", (0, $9e4b481250188a54$export$c11650baacf39e2f));
    customElements.define("pick-winner-modal", (0, $3eb993ebf650684c$export$626d11413ed62030));
    customElements.define("base-heal-animation", (0, $4f46944e3481f56f$export$1687a8750135f014));
    customElements.define("player-leader", (0, $aa9c6d01304a85fe$export$7ec8a35823165bea));
    customElements.define("base-damage-animation", (0, $34240cdfec9b798d$export$18bf9156e6515ba8));
    customElements.define("game-timer", (0, $cee30dd3c9eb63a8$export$15afaf45c56450ea));
    customElements.define("log-modal", (0, $13acaba22642f788$export$b7fea4424a75e2e7));
    customElements.define("initiative-modal", (0, $bec6e70bc6563a27$export$88c326727b6c1d28));
}




// package.json
var $cdac2aaac005f1e8$var$name = "@vercel/analytics";
var $cdac2aaac005f1e8$var$version = "1.5.0";
// src/queue.ts
var $cdac2aaac005f1e8$var$initQueue = ()=>{
    if (window.va) return;
    window.va = function a(...params) {
        (window.vaq = window.vaq || []).push(params);
    };
};
// src/utils.ts
function $cdac2aaac005f1e8$var$isBrowser() {
    return typeof window !== "undefined";
}
function $cdac2aaac005f1e8$var$detectEnvironment() {
    try {
        const env = "production";
        if (env === "development" || env === "test") return "development";
    } catch (e) {}
    return "production";
}
function $cdac2aaac005f1e8$var$setMode(mode = "auto") {
    if (mode === "auto") {
        window.vam = $cdac2aaac005f1e8$var$detectEnvironment();
        return;
    }
    window.vam = mode;
}
function $cdac2aaac005f1e8$var$getMode() {
    const mode = $cdac2aaac005f1e8$var$isBrowser() ? window.vam : $cdac2aaac005f1e8$var$detectEnvironment();
    return mode || "production";
}
function $cdac2aaac005f1e8$var$isProduction() {
    return $cdac2aaac005f1e8$var$getMode() === "production";
}
function $cdac2aaac005f1e8$var$isDevelopment() {
    return $cdac2aaac005f1e8$var$getMode() === "development";
}
function $cdac2aaac005f1e8$var$removeKey(key, { [key]: _, ...rest }) {
    return rest;
}
function $cdac2aaac005f1e8$var$parseProperties(properties, options) {
    if (!properties) return void 0;
    let props = properties;
    const errorProperties = [];
    for (const [key, value] of Object.entries(properties))if (typeof value === "object" && value !== null) {
        if (options.strip) props = $cdac2aaac005f1e8$var$removeKey(key, props);
        else errorProperties.push(key);
    }
    if (errorProperties.length > 0 && !options.strip) throw Error(`The following properties are not valid: ${errorProperties.join(", ")}. Only strings, numbers, booleans, and null are allowed.`);
    return props;
}
function $cdac2aaac005f1e8$export$c689ba62f1421710(pathname, pathParams) {
    if (!pathname || !pathParams) return pathname;
    let result = pathname;
    try {
        const entries = Object.entries(pathParams);
        for (const [key, value] of entries)if (!Array.isArray(value)) {
            const matcher = $cdac2aaac005f1e8$var$turnValueToRegExp(value);
            if (matcher.test(result)) result = result.replace(matcher, `/[${key}]`);
        }
        for (const [key, value] of entries)if (Array.isArray(value)) {
            const matcher = $cdac2aaac005f1e8$var$turnValueToRegExp(value.join("/"));
            if (matcher.test(result)) result = result.replace(matcher, `/[...${key}]`);
        }
        return result;
    } catch (e) {
        return pathname;
    }
}
function $cdac2aaac005f1e8$var$turnValueToRegExp(value) {
    return new RegExp(`/${$cdac2aaac005f1e8$var$escapeRegExp(value)}(?=[/?#]|$)`);
}
function $cdac2aaac005f1e8$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $cdac2aaac005f1e8$var$getScriptSrc(props) {
    if (props.scriptSrc) return props.scriptSrc;
    if ($cdac2aaac005f1e8$var$isDevelopment()) return "https://va.vercel-scripts.com/v1/script.debug.js";
    if (props.basePath) return `${props.basePath}/insights/script.js`;
    return "/_vercel/insights/script.js";
}
// src/generic.ts
function $cdac2aaac005f1e8$export$a976684a0efeb93f(props = {
    debug: true
}) {
    var _a;
    if (!$cdac2aaac005f1e8$var$isBrowser()) return;
    $cdac2aaac005f1e8$var$setMode(props.mode);
    $cdac2aaac005f1e8$var$initQueue();
    if (props.beforeSend) (_a = window.va) == null || _a.call(window, "beforeSend", props.beforeSend);
    const src = $cdac2aaac005f1e8$var$getScriptSrc(props);
    if (document.head.querySelector(`script[src*="${src}"]`)) return;
    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    script.dataset.sdkn = $cdac2aaac005f1e8$var$name + (props.framework ? `/${props.framework}` : "");
    script.dataset.sdkv = $cdac2aaac005f1e8$var$version;
    if (props.disableAutoTrack) script.dataset.disableAutoTrack = "1";
    if (props.endpoint) script.dataset.endpoint = props.endpoint;
    else if (props.basePath) script.dataset.endpoint = `${props.basePath}/insights`;
    if (props.dsn) script.dataset.dsn = props.dsn;
    script.onerror = ()=>{
        const errorMessage = $cdac2aaac005f1e8$var$isDevelopment() ? "Please check if any ad blockers are enabled and try again." : "Be sure to enable Web Analytics for your project and deploy again. See https://vercel.com/docs/analytics/quickstart for more information.";
        console.log(`[Vercel Web Analytics] Failed to load script from ${src}. ${errorMessage}`);
    };
    if ($cdac2aaac005f1e8$var$isDevelopment() && props.debug === false) script.dataset.debug = "false";
    document.head.appendChild(script);
}
function $cdac2aaac005f1e8$export$6b2a7d5132615086(name2, properties, options) {
    var _a, _b;
    if (!$cdac2aaac005f1e8$var$isBrowser()) {
        const msg = "[Vercel Web Analytics] Please import `track` from `@vercel/analytics/server` when using this function in a server environment";
        if ($cdac2aaac005f1e8$var$isProduction()) console.warn(msg);
        else throw new Error(msg);
        return;
    }
    if (!properties) {
        (_a = window.va) == null || _a.call(window, "event", {
            name: name2,
            options: options
        });
        return;
    }
    try {
        const props = $cdac2aaac005f1e8$var$parseProperties(properties, {
            strip: $cdac2aaac005f1e8$var$isProduction()
        });
        (_b = window.va) == null || _b.call(window, "event", {
            name: name2,
            data: props,
            options: options
        });
    } catch (err) {
        if (err instanceof Error && $cdac2aaac005f1e8$var$isDevelopment()) console.error(err);
    }
}
function $cdac2aaac005f1e8$export$b81f1580747d8b3a({ route: route, path: path }) {
    var _a;
    (_a = window.va) == null || _a.call(window, "pageview", {
        route: route,
        path: path
    });
}
var $cdac2aaac005f1e8$export$2e2bcd8739ae039 = {
    inject: $cdac2aaac005f1e8$export$a976684a0efeb93f,
    track: $cdac2aaac005f1e8$export$6b2a7d5132615086,
    computeRoute: $cdac2aaac005f1e8$export$c689ba62f1421710
};


// New code
function $022ef55e869009bb$var$registerListeners() {
    (0, $49a3b7170c6ecdc1$export$5dc36268de8a8ad4)((e)=>{
        console.log("\uD83E\uDDD9\u200D\u2642\uFE0F: State updated", e.detail);
    });
}
(0, $cfdf6f1829f6520f$export$34dc4cbf9ab25369)();
(0, $49a3b7170c6ecdc1$export$8d6594f2ef703eca)();
(0, $440d289ff3253aed$export$b6af53c581e4325c)();
$022ef55e869009bb$var$registerListeners();
(0, $cdac2aaac005f1e8$export$a976684a0efeb93f)();

})();
//# sourceMappingURL=scripts.js.map
